import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3aeadca0"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]

import { ProductUspTileModel } from '@/types/B2CcontentServerContract';
import { isReadable } from '@ctrl/tinycolor';
import { computed } from 'vue';
import colors from '@/styling/0-Settings/colors.js';


export default /*#__PURE__*/_defineComponent({
  __name: 'USPTile',
  props: {
    content: null
  },
  setup(__props: any) {

const props = __props as {
    content: ProductUspTileModel;
}



const invertTextColor = computed<boolean>(() => {
    return !!props.content.hexCode && !isReadable('#000', props.content.hexCode);
});

const textColorClass = computed(() => {
    return invertTextColor.value ? 'text-white' : 'text-black';
});

const iconColorClass = computed(() => {
    return invertTextColor.value ? 'icon-white' : 'icon-black';
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("ul", {
    class: "w-full flex flex-wrap justify-center pb-15 pl-40",
    style: _normalizeStyle({ backgroundColor: __props.content.hexCode || _unref(colors).brandy })
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.content.uspItems, (usp) => {
      return (_openBlock(), _createElementBlock("li", {
        key: usp.title,
        class: "flex mt-15 pr-40 sm:pr-75 items-center"
      }, [
        _createElementVNode("img", {
          src: usp.icon.model.url,
          "aria-hidden": "true",
          class: _normalizeClass(["h-15 mr-8 sm:mr-25", _unref(iconColorClass)])
        }, null, 10, _hoisted_1),
        _createTextVNode(),
        _createElementVNode("span", {
          class: _normalizeClass([_unref(textColorClass), "whitespace-nowrap"])
        }, _toDisplayString(usp.title), 3)
      ]))
    }), 128))
  ], 4))
}
}

})